import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { fetchAIInsights } from "../api";
import { API_BASE_URL } from "../config";
import { useAuth } from "../state/AuthContext";

const prompts = [
  "What are the key growth drivers next quarter?",
  "How does leverage compare to peers?",
  "Summarize major risks and mitigants.",
];

const AIAssistant = ({ ticker, onAsk, answer: controlledAnswer }) => {
  const { token } = useAuth();
  const [question, setQuestion] = useState(prompts[0]);
  const [answer, setAnswer] = useState(controlledAnswer || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (controlledAnswer) setAnswer(controlledAnswer);
  }, [controlledAnswer]);

  const handleAsk = async () => {
    console.log("[AIAssistant] handleAsk called. Token:", token ? token.substring(0, 10) : "None");
    if (!token) return; // Should be handled by UI rendering
    if (!question) return;
    setLoading(true);
    if (onAsk) {
      const response = await onAsk(question, token);
      setAnswer(response);
    } else {
      const response = await fetchAIInsights({ ticker, question }, token);
      setAnswer(response);
    }
    setLoading(false);
  };


  const handleLogin = (provider) => {
    // Save current state so we can restore it after redirect
    sessionStorage.setItem("pending_dashboard", JSON.stringify({ ticker: ticker, tab: "ai" }));

    const next = encodeURIComponent(window.location.origin);
    window.location.href = `${API_BASE_URL}/auth/login/${provider}?next=${next}`;
  };

  if (!token) {
    return (
      <div className="auth-prompt">
        <h3>
          Analyst AI
        </h3>
        <p>Sign in to unlock professional-grade financial insights.</p>
        <div className="auth-buttons-container">
          <button
            className="button auth-btn google-btn"
            onClick={() => handleLogin('google')}
          >
            <span className="icon">G</span> Sign in with Google
          </button>
          <button
            className="button auth-btn github-btn"
            onClick={() => handleLogin('github')}
          >
            <span className="icon">GH</span> Sign in with GitHub
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="stack">
      <div className="chip-row">
        {prompts.map((p) => (
          <button key={p} className="nav-link" onClick={() => setQuestion(p)}>
            {p}
          </button>
        ))}
      </div>
      <textarea
        className="input"
        style={{ minHeight: 90 }}
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
      />
      <button className="button" onClick={handleAsk} disabled={loading}>
        {loading ? "Thinking..." : "Ask AI"}
      </button>
      {answer && (
        <div className="panel">
          <div className="tag">{ticker} AI Insights</div>
          <div style={{ marginTop: 8, color: "#e8ecf5" }} className="ai-markdown">
            <ReactMarkdown>
              {answer.answer}
            </ReactMarkdown>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIAssistant;
